import api from 'api'

export type GetAdminUserWorkParams = {
  userId: number
  limit: number
  grouping?: string | null
  status?: string | null
  startDate?: string | null
  endDate?: string | null
}

type GetAdminUserWorkResult = {
  data: {
    admin: {
      user: {
        work: unknown[]
      }
    }
  }
}

/**
 * Fetch admin user work via the REST dispatch endpoint.
 * Replaces the legacy USER_WORK_QUERY GraphQL flow.
 */
export async function getAdminUserWork(
  params: GetAdminUserWorkParams
): Promise<unknown[]> {
  const body: Record<string, unknown> = {
    userId: params.userId,
    limit: params.limit,
    ...(params.grouping != null && { grouping: params.grouping }),
    ...(params.status != null && { status: params.status }),
    ...(params.startDate != null && { startDate: params.startDate }),
    ...(params.endDate != null && { endDate: params.endDate }),
  }

  const response = await api.post<GetAdminUserWorkResult>(
    '/admin/graphql_dispatch/admin_user_work_f8b9c0d1',
    body
  )
  return response.data.data.admin.user.work ?? []
}
